
import React from 'react';
import {Action, Info, Spinner} from "../../funcs/utils";
import { render_recurring_payment_2 } from "../../../lib/onboarding-shared/widgets/recurring-payment";
import { RadioButton } from "../../../lib/prm/radio-button";
import { Name } from "../../../lib/prm/name";
import { Text } from "../../../lib/prm/text";
import { AllNames } from "../../../lib/onboarding-tda/shared-prms";
import { dollarValidator } from "../../../lib/prm/text";
import { OptionMenu } from "../../../lib/prm/option-menu";
import { FlowRender } from "../../../lib/flow-render";
import { deep_copy } from "../../../lib/js-utils";
import { sprintf } from "sprintf-js";
import {UserAcctType} from "../../../lib/dwolla/constants";
import { PaymentsContainer2 } from "./common";
import {DEVICE_WIDTH} from "../../../lib/constants";
import { ExecutePaymentDialog2 } from "../../payment/execute-payment-2";
import {price_string_to_dollars} from "../../../lib/currency-utils";
import {ContribErrorDialog} from "./contribution-dialog";
import {setContributionRequest} from "../../payment/actions";

const contribute_yes_no = new RadioButton(
  new Name(AllNames.contribute_yes_no,
    "Do you want to contribute on a regular basis?"),
  [
    new Name("yes", "Yes"),
    new Name("no", "No"),
  ]
);

const contribute_amt = new Text(
  new Name(AllNames.contribute_amt, "How much"));
contribute_amt.setValidator(dollarValidator);

// Cadence values match @ca/time Cadence
const contribute_cadence = new OptionMenu(
  new Name(AllNames.contribute_cadence, "How often"),
  [
    new Name("instant", "One Time"),
    new Name("MONTHLY", "Monthly"),
    new Name("QUARTERLY", "Quarterly"),
    new Name("ANNUALLY", "Annually"),
  ]
);

const ALL_PRMS = new FlowRender(0, [
  contribute_yes_no,
  contribute_amt,
  contribute_cadence,
]);

const on_tab_click = (component, tab_id) => {
  const args = deep_copy(component.props.args);
  args.tab = tab_id;
  component.props.navigatePath(component.props.path, args);
}


const load_payment_info = (component) => {
  component.props.GetPaymentInformation(component.props.username);
};

const SetupPaymentCard = props => {

  const { component }= props;
  const is_loading = component.props.userPayments.loading || component.state.setting_contribution;
  const raw_cadence = contribute_cadence.getValue(component.state);
  const is_instant_payment = raw_cadence && raw_cadence.id === "instant";
  const button_text = is_instant_payment ? "Make Payment" : "Update Contribution Schedule";
  const action_text = is_loading ? (<Spinner/>) : button_text;
  const device = {
    width: component.props.app.width,
  }
  const do_medium = component.props.app.width < DEVICE_WIDTH.medium;

  const on_payment_cb = () => {
    component.setState({
      show_payment_popup: true,
      error_msg: null,
    });
  };
  const update_contributions_cb = () => {
    const do_contrib = true;
    const amt_usd = price_string_to_dollars(contribute_amt.getValue(component.state));
    const cadence = contribute_cadence.getValue(component.state).id;
    if (amt_usd <= 0) {
      component.setState({
        contribution_error_dialog: true,
      });
      return;
    }
    component.setState({
      setting_contribution: true,
    })
    setContributionRequest(
      component.props.token, do_contrib, cadence, amt_usd, component.props.acct_index)
      .then(() => {
        component.setState({
          setting_contribution: false,
        })
        load_payment_info(component);
        on_tab_click(component, "future");
      })
  };
  const button_container = {
    marginTop: "2rem",
  };

  const action_button = (
    <div style={button_container}>
      <div align={"center"}>
        <Action
          onClick={is_instant_payment ? on_payment_cb : update_contributions_cb}
          disabled={!component.state.dirty && !is_instant_payment}>
          { action_text }
        </Action>
      </div>
    </div>
  );

  const header = (
    <div style={{width: "100%", paddingLeft: "1rem"}}>
      { render_recurring_payment_2(
        component, contribute_yes_no, contribute_amt, contribute_cadence,
        component.props.app.width) }
    </div>
  )
  const medium_layout = component.props.app.width <= DEVICE_WIDTH.large;
  const info_text = "You can transfer money into your investment account as a one-time deposit or set-up automatic regular contributions.";
  const info = (
    <Info
      id={"setup_deposit"}
      text={info_text}
      popup_style={{ width: "30rem" }}
      style={{fontSize: do_medium ? "1rem" : "1.5rem"}}
      component={component}/>
  );
  const on_done = result => {
    component.setState({
      show_payment_popup: false,
      payment_dollar: "0.00",
      payment_dollar_dirty: false,
      execute_payment: false,
    });
    load_payment_info(component, false, result && result.dwolla);
    on_tab_click(component, "current");
  }

  const username = component.props.user.username;
  const index = parseInt(component.props.args.acct_index, 10);
  const payment_from = {
    username,
    acct: UserAcctType.EXTERNAL,
  }
  const payment_to = {
    username,
    acct: sprintf("%04d", index),
  }
  const contrib_dialog = component.state.contribution_error_dialog
    ? (<ContribErrorDialog component={component}/>) : null;

  return (
    <PaymentsContainer2
      title={"Setup a Deposit"}
      device={device}
      client={component.props.client}
      suffix={info}
      header={medium_layout ? null : header}>
      { medium_layout ? header : null }
      { action_button }
      { contrib_dialog }
      <ExecutePaymentDialog2
        component={component}
        payment_from={payment_from}
        payment_to={payment_to}
        contrib_prm={contribute_amt}
        on_payment_done={on_done}/>
    </PaymentsContainer2>
  );

};

const setup_payment_state = (component) => {
  const state = {
    loading: false,
    payment_dollar: "0.00",
    show_payment_popup: false,
    execute_payment: false,
    setting_contribution: false,
    jan_date: {
      year: new Date().getFullYear(),
      month: 1,
      day: 31,
    },
  };
  ALL_PRMS.init(state, {}, component);
  return state;
}

export { SetupPaymentCard, load_payment_info, setup_payment_state };
